(ns teamoesterreich.user-mode.info.dsgvo
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.config :as config]
            [teamoesterreich.firebase.remote-config :as remote-config]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.modal.are-you-sure-modal :as are-you-sure-modal]
            [teamoesterreich.util.log :as log]
            ))


(defn page []
  (let [!delMePopup (r/cursor store/app-state [:!delMePopup])
        !actual-user (r/cursor store/app-state [:actual-user])
        !tom-id (r/cursor store/app-state [:actual-user :tom-id])
        ]
    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "center"
      :alignItems "flex-start"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:item true
       :xl   6                                              ;extra-large: 1920px
       :lg   6                                              ;large: 1280px
       :md   6                                              ;medium: 960px
       :sm   12                                             ;small: 600px
       :xs   12                                             ;extra-small: 0px
       }
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}


       [:h1 "Datenschutz"]
       (when (and
               @!tom-id
               (= "toe" config/CLIENT)
               )
         [:div
          [:h2 "Online-Nennung"]

          [mui/form-group
           [mui/form-control-label
            {:style     {:paddingLeft "26px"}
             :label     "Online Nennung"
             :fullWidth true
             :control   (r/as-element
                          [mui/switch
                           {
                            :checked  (if (false? (get-in @!actual-user [:privacy :toe_mention])) false true)
                            :onChange (fn [_ v]
                                        (log/debug "switch oe3 changed" v)
                                        (a/set-user-details {:privacy (merge (get-in @!actual-user [:privacy])
                                                                             [:toe_mention v])})
                                        )
                            }])}
            ]]
          [:p
           "Ich bin damit einverstanden, dass ich als Teilnehmer an der Aktion Team Österreich im Internet genannt werde. Ich stimme zu, dass meine Daten (Vor- und Nachname, Beruf, Alter und Wohnort)"
           " zu diesem Zweck vom Österreichischen Roten Kreuz an Ö3 übermittelt werden. Ich akzeptiere die Datenschutzbestimmungen von Ö3."
           ]



          ;;------------------------
          ;;------------------------
          [:h2 "Newsletter"]
          [mui/form-group
           [mui/form-control-label
            {:style     {:paddingLeft "26px"}
             :label     "Newsletter des Österreichischen Roten Kreuzes"
             :fullWidth true
             :control   (r/as-element
                          [mui/switch
                           {
                            :checked  (if (false? (get @!actual-user :newsletter-rk)) false true)
                            :onChange (fn [_ v]
                                        (a/set-user-details {:newsletter-rk v
                                                             :privacy       (merge (get-in @!actual-user [:privacy])
                                                                                   [:newsletter-rk v])})
                                        )
                            }])}
            ]]
          [:p
           "Ich möchte den Newsletter des Österreichischen Roten Kreuzes abonnieren."
           "Diese Einwilligung kann ich jederzeit mittels Link in jedem Newsletter und durch Entfernen dieses Hakens widerrufen. "
           [:br]
           "Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt."
           ]
          [mui/form-group
           [mui/form-control-label
            {:style     {:paddingLeft "26px"}
             :label     "Informationen von Ö3"
             :fullWidth true
             :control   (r/as-element
                          [mui/switch
                           {
                            :checked  (if (false? (get @!actual-user :newsletter-oe3)) false true)
                            :onChange (fn [_ v]
                                        (a/set-user-details {:newsletter-oe3 v
                                                             :privacy        (merge (get-in @!actual-user [:privacy])
                                                                                    [:newsletter-oe3 v])})
                                        )
                            }])}
            ]]
          [:p
           "Ich möchte weitere Informationen von Ö3 erhalten und willige ein, dass mein Vorname, Nachname, Alter und E-Mail-Adresse "
           "an den ORF und Tochterunternehmen bzw. verbundenen Unternehmen des ORF übermittelt und von diesen verwendet werden, um mir"
           [:ul
            [:li "Informationen über Rundfunk- und Onlineangebote und damit zusammenhängende Informationsdienste des ORF (z. B. Newsletter),"]
            [:li "technische Informationen (z. B. Neuerungen/Änderungen bei Sendefrequenzen),"]
            [:li "Informationen über sonstige Produkte des ORF (z. B. Internet-, SMS- und Telefondienste, Produkte aus dem ORF-Shop)"]
            ]
           "sowie über"
           [:ul
            [:li "vom ORF veranstaltete oder unterstützte Veranstaltungen (z. B. Ö3-Disco),"]
            [:li "Gewinnspiele und Spendenaktionen (z. B. Licht ins Dunkel)"]
            ]
           "per E-Mail zukommen zu lassen."
           [:br]
           "Diese Unternehmen sind: ORF-Enterprise GmbH, ORF-Enterprise GmbH & Co KG, ORF Promotion & Programmservice GmbH & Co KG, "
           "ORF Marketing Service GmbH, Verein für Licht ins Dunkel, ORF Marketing & Creation GmbH und Co KG, GIS Gebühren Info Service GmbH, "
           "Österreichische Rundfunksender GmbH, Österreichische Rundfunksender GmbH & Co KG, ORS comm GmbH, ORS comm GmbH & Co KG, "
           "Digitales Fernsehen Förder GmbH, ORF Online & Teletext GmbH, ORF Online & Teletext GmbH & Co KG, ORF KONTAKT Kundenservice GmbH & Co KG, "
           "ORF Mediaservice GmbH, ORF Mediaservice GmbH & Co KG, TW1 Betriebsführungs GmbH, ORF Fernsehprogramm-Service GmbH, ORF Landesstudio Service GmbH, "
           "ORF Landesstudio Service GmbH & Co KG."
           [:br]
           [:br]
           "Die Zustimmung zu dieser Verwendung kann ich jederzeit durch Entfernen dieses Hakens, "
           "ODER mit Brief an Hitradio Ö3, ORF, 1136 Wien oder per E-Mail an " [:a {:href "hitradio@oe3.at"} "hitradio@oe3.at"] " oder mit einem Anruf unter "
           "0800 600 600 (zum Nulltarif, täglich von 7-19 Uhr) mit Wirkung für die Zukunft widerrufen, "
           "aus technischen Gründen jedoch nicht hier auf der Website des Team Österreich. "
           "Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt."
           [:br]
           "Weitere Informationen zu den Datenschutzbestimmungen von Ö3 findest du " [:a {:href "https://oe3dabei.orf.at/index.php?pageID=444"} "hier."]
           ]




          ;;------------------------



          [:h2 "Daten löschen"]
          [:div "Klicke hier um die Löschung ALLER deiner Userdaten zu beantragen und die Mitgliedschaft im Team Österreich zu beenden."]

          [are-you-sure-modal/are-you-sure-confirm-modal !delMePopup
           [:p
            "Bist du sicher, dss du ALLE deine Nutzerdaten im Teamösterreich löschen möchtest?"
            [:br]
            " Dann schreibe \"löschen\" in das Feld."]
           "löschen"
           "löschen"
           (fn []
             (a/set-user-details {:request-deletion true})
             (reset! !delMePopup nil))
           ]

          (if (get-in @!actual-user [:request-deletion])
            [:div
             [:div {:style {:color "red" :border "1px red dotted" :width "500px" :textAlign "center" :padding "5px"}}
              "Aktiver Löschantrag!"]

             [mui/button
              {:variant "contained"
               :color   "primary"
               :style   {:margin "10px 0 10px 45px" :width "300px"}
               :onClick #(a/set-user-details {:request-deletion false})
               }
              "Löschantrag zurücknehmen"]
             ]
            [mui/button
             {:variant "contained"
              :style   {:margin "10px 0 10px 45px" :width "300px"}
              :onClick #(reset! !delMePopup true

                                )
              }
             "Löschung beantragen"])

          ]
         )


       [:h2 "Datenschutz"]
       [:div {:dangerouslySetInnerHTML {:__html (remote-config/get-string "privacy_policy_html")}}]

       [mui/button
        {:variant "contained"
         :style   {:margin "10px 0 10px 45px" :width "300px"}
         :onClick #(a/set-page-back)
         }
        "Zurück"]
       [:br] [:br]

       ]
      ]
     ]))


(defn get-it []
  (let [!st (atom {})]
    [page !st])
  )